export const weightsPresetsKeys = {
  all: ["weights-presets"] as const,
  list: () => [...weightsPresetsKeys.all, "list"] as const,
  default: () => [...weightsPresetsKeys.all, "default"] as const,
};
